import { ItemQuoteProps } from "models/Quote";
import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  setUnitPriceValue: ['data'],
  removeUnitPriceValue: []
});

const INITIAL_STATE: ItemQuoteProps = { };

const setUnitPriceValue = (state = INITIAL_STATE, action: any) => ({ ...action.data });

const removeUnitPriceValue = (state = INITIAL_STATE, action: any) => ({});

export default createReducer(INITIAL_STATE, {
  [Types.SET_UNIT_PRICE_VALUE as any]: setUnitPriceValue,
  [Types.REMOVE_UNIT_PRICE_VALUE as any]: removeUnitPriceValue
});
